import * as Route from '../support/serverRoutes';
import makeRequest from '../../main/utils/makeRequest';
import { setCollectionValueByKey } from '../../main/utils/helpers';
import { BLOCKS } from '../utils/factories';

const blocks = {
  state: {
    data: {},
    collections: [],
    fetchParams: {},
    loading: false,
  },
  reducers: {
    setData(state, data) {
      return { ...state, data };
    },
    setCollection(state, collections) {
      return { ...state, collections };
    },
    setLoading(state, loading) {
      return { ...state, loading };
    },
    setFetchParams(state, params) {
      return { ...state, fetchParams: params };
    },
  },
  effects: (dispatch) => ({
    fetchBlocks({ by, byId, pageName }) {
      // Get collectionsInit from factory blocks at runtime
      let collectionsInit;
      switch (pageName) {
        case 'super_admin':
          collectionsInit = [
            BLOCKS.establishmentAndClass,
            BLOCKS.adminsAndEducators,
            BLOCKS.students,
            BLOCKS.activity,
            BLOCKS.totalProgress,
            BLOCKS.licences,
          ];
          break;
        case 'admin':
          collectionsInit = [
            BLOCKS.students,
            BLOCKS.totalProgress,
            BLOCKS.activity,
            BLOCKS.classes,
            BLOCKS.subscriptionAndLicence,
          ];
          break;
        case 'lecturer':
          collectionsInit = [
            BLOCKS.students,
            BLOCKS.totalProgress,
            BLOCKS.activity,
          ];
          break;
        case 'classroom':
          collectionsInit = [
            BLOCKS.students,
            BLOCKS.totalProgress,
            BLOCKS.activity,
          ];
          break;
        case 'project':
          collectionsInit = [BLOCKS.totalProgress, BLOCKS.activity];
          break;
        default:
          collectionsInit = [];
      }
      dispatch.blocks.setLoading(true);
      dispatch.blocks.setCollection(collectionsInit);
      dispatch.blocks.setFetchParams({ by, byId, pageName });

      makeRequest({
        dispatch,
        url: Route.blocks({ by, byId, pageName }),
        success: (response) => {
          dispatch.blocks.setCollection(
            setCollectionValueByKey(collectionsInit, response.data.data),
          );
        },
        finish: () => {
          dispatch.blocks.setLoading(false);
        },
      });
    },

    fetchBlock({ by, byId, pageName }) {
      dispatch.blocks.setLoading(true);
      dispatch.blocks.setFetchParams({ by, byId, pageName });

      makeRequest({
        dispatch,
        url: Route.blocks({ by, byId, pageName }),
        success: (response) => {
          dispatch.blocks.setData(response.data.data);
        },
        finish: () => {
          dispatch.blocks.setLoading(false);
        },
      });
    },

    reload(_, rootState) {
      dispatch.blocks.fetchBlocks(rootState.blocks.fetchParams);
    },
  }),
};

export default blocks;
